/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1CountriesQueryResponse } from '../../types/GetV1Countries.ts'

export const getV1CountriesQueryKey = () => [{ url: '/v1/Countries' }] as const

export type GetV1CountriesQueryKey = ReturnType<typeof getV1CountriesQueryKey>

/**
 * {@link /v1/Countries}
 */
export async function getV1Countries(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1CountriesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Countries`,
        ...requestConfig,
    })
    return res
}

export function getV1CountriesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1CountriesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1CountriesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1CountriesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Countries(config)
        },
    })
}

/**
 * {@link /v1/Countries}
 */
export function useGetV1Countries<
    TData = ResponseConfig<GetV1CountriesQueryResponse>,
    TQueryData = ResponseConfig<GetV1CountriesQueryResponse>,
    TQueryKey extends QueryKey = GetV1CountriesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1CountriesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1CountriesQueryKey()

    const query = useQuery(
        {
            ...getV1CountriesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
